document.addEventListener("DOMContentLoaded", function() {
    const popupWrapper = document.querySelector('.popup-instagram--wrapper');
    const popupTrigger = document.querySelector('.popup-instagram--trigger');
    const popupTriggerClose = document.querySelector('.popup-instagram--trigger-close');
    const closeButton = document.querySelector('.pop-up-instagram--close');

    // Vérifiez si la popup a déjà été fermée dans les cookies
    const popupClosed = sessionStorage.getItem('popupInstagramClosed');
    
    if (!popupClosed) {
        // Affichez la popup après 10 secondes
        setTimeout(() => {
            popupWrapper.classList.remove('popup-instagram--wrapper--hidden');
            popupWrapper.classList.add('popup-instagram--wrapper--active');
        }, 10000);
    }

    popupTrigger.addEventListener('click', function() {
        popupWrapper.classList.remove('popup-instagram--wrapper--hidden');
        popupWrapper.classList.add('popup-instagram--wrapper--active');
    });

    popupTriggerClose.addEventListener('click', function(event) {
        event.stopPropagation();
        popupTrigger.style.display = 'none';
    });

    closeButton.addEventListener('click', function() {
        popupWrapper.classList.remove('popup-instagram--wrapper--active');
        popupWrapper.classList.add('popup-instagram--wrapper--hidden');
        sessionStorage.setItem('popupInstagramClosed', 'true');

        // Stockez un cookie qui expire après 2 semaines (en millisecondes)
        const twoWeeks = 2 * 7 * 24 * 60 * 60 * 1000;
        const expirationDate = new Date(Date.now() + twoWeeks);
        document.cookie = `popupClosed=true; expires=${expirationDate.toUTCString()}`;
    });
});
